import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import { OptionListItem as OptionListItemRoot } from './style';
import { Checkbox } from '../Checkbox';
import { Typography } from '../Typography';
import { useOptionListItem } from './utils/useOptionListItem';
import { OPTION_LIST_ITEM_CLASS_PREFIX } from './constants';
import { useOptionListItemClassName } from './utils/useOptionListItemClassName';
import { useComponentTheme } from '../../utils/hooks';
export var OptionListItem = function OptionListItem(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(OPTION_LIST_ITEM_CLASS_PREFIX);
  var classOverride = useOptionListItemClassName(OPTION_LIST_ITEM_CLASS_PREFIX, className);

  var _useOptionListItem = useOptionListItem(props),
      rootProps = _useOptionListItem.rootProps,
      checkboxProps = _useOptionListItem.checkboxProps,
      typographyProps = _useOptionListItem.typographyProps,
      multiple = _useOptionListItem.multiple,
      label = _useOptionListItem.label;

  return React.createElement(OptionListItemRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classOverride.Root
  }), multiple && React.createElement(Checkbox, Object.assign({}, checkboxProps, {
    theme: theme,
    className: classOverride.Checkbox
  })), React.createElement(Typography, Object.assign({}, typographyProps, {
    theme: theme,
    className: classOverride.Typography
  }), label));
};